import React, { useEffect, useRef, useState } from 'react';
import { googleConfig } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';

const carregarScript = () => new Promise((resolve, reject) => {
  if (window.google?.accounts?.id) { resolve(); return; }
  const existente = document.querySelector('script[data-gsi]');
  if (existente) { existente.addEventListener('load', resolve); existente.addEventListener('error', reject); return; }
  const sc = document.createElement('script');
  sc.src = 'https://accounts.google.com/gsi/client';
  sc.async = true;
  sc.defer = true;
  sc.dataset.gsi = '1';
  sc.onload = resolve;
  sc.onerror = reject;
  document.head.appendChild(sc);
});

const GoogleAuth = ({ onSuccess }) => {
  const { loginWithGoogle } = useAuth();
  const { toast } = useToast();
  const alvo = useRef(null);
  const aoSucesso = useRef(onSuccess);
  const [ativo, setAtivo] = useState(false);
  aoSucesso.current = onSuccess;

  useEffect(() => {
    let cancelado = false;
    (async () => {
      const { client_id: clientId } = await googleConfig();
      if (!clientId || cancelado) return;
      await carregarScript();
      if (cancelado) return;
      setAtivo(true);
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: async (resp) => {
          try {
            const u = await loginWithGoogle(resp.credential);
            toast({ title: 'Login realizado!', description: `Bem-vindo, ${u.name}.` });
            aoSucesso.current?.(u);
          } catch (err) {
            toast({ title: 'Erro ao entrar com Google', description: err?.response?.data?.detail || 'Tente novamente.' });
          }
        },
      });
      if (alvo.current) {
        window.google.accounts.id.renderButton(alvo.current, {
          theme: 'outline', size: 'large', shape: 'pill', text: 'continue_with', locale: 'pt-BR', width: 320,
        });
      }
    })().catch(() => {});
    return () => { cancelado = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={ativo ? 'mt-6' : 'hidden'}>
      <div className="flex items-center gap-3 text-xs text-slate-400 mb-4">
        <div className="flex-1 h-px bg-slate-200" /> ou <div className="flex-1 h-px bg-slate-200" />
      </div>
      <div ref={alvo} className="flex justify-center min-h-[44px]" />
    </div>
  );
};

export default GoogleAuth;
